<mat-dialog-content class="content-dialog">
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-text">Add as a prospect</div>
      <button
        mat-flat-button
        class="md circle"
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div
      class="dialog-content"
      [formGroup]="form"
    >
      <div class="search-input">
        <mojo-autocomplete
          (inputChange)="onInputChange($event)"
          formControlName="job"
          label="Search for job name or job ID"
          placeholder=""
          [multi]="false"
          [useChips]="false"
          [options]="jobs$ | async"
          bindLabel="label"
          appearance="fill"
          color="accent"
        ></mojo-autocomplete>
      </div>
      <div class="modal-buttons">
        <button
          color="accent"
          class="mr-2"
          mat-button
          type="button"
          (click)="closeDialog()"
        >Cancel
        </button>
        <button
          color="primary"
          class="md"
          mat-flat-button
          type="button"
          [disabled]="form.invalid"
          (click)="onAddProspect()"
        >Add
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
